import React from "react"
import { getIconFromUrl } from "utils/iconResolver"
import styled from "styled-components"
import Section from "../Section"
import Content from "../Content"
import ContentCard from "../ContentCard"
import CardContainer from "../CardContainer"
import { valuable } from "utils/worthy"
import { lengthToFractions, setGridSize } from "utils/gridResolver"

const StyledSection = styled(Section)`
  h2 {
    text-transform: uppercase;
  }
`

function ContentCardSlice({ main, cards, ...props }) {
  const { card_group_title } = main
  let title = valuable(card_group_title) ? (
    <Content content={card_group_title} />
  ) : null

  const gridLength = setGridSize(cards.length, 3)

  return (
    <StyledSection align="center" prepend={title}>
      <CardContainer columns={lengthToFractions(gridLength)}>
        {cards.map((card, i) => {
          const { card_icon, card_title, card_content } = card
          const icon = getIconFromUrl(card_icon.url)
          return (
            <ContentCard
              key={`card_${i}`}
              size="md"
              bg="white"
              color="primary"
              iconBg="kelp"
              iconColor="foam"
              icon={icon}
            >
              <Content content={card_title} />
              <Content content={card_content} />
            </ContentCard>
          )
        })}
      </CardContainer>
    </StyledSection>
  )
}

export default ContentCardSlice
